/**
 * Quantity
 */
export interface Quantity {
  type: QuantityType;
  quantity: number;
}

export enum QuantityType {
  PAX = 'PAX',
  USER_SELECTED = 'USER_SELECTED',
}

export interface PaxQuantity extends Quantity {
  type: QuantityType.PAX;
}

export interface UserSelectedQuantity extends Quantity {
  type: QuantityType.USER_SELECTED;
}
